// Pure decision for the S2 frontend activation pre-check: given the result of
// a token-refresh edge call for the campaign's sending account, decide whether
// to block activation and what to tell the user.
export interface TokenRefreshOutcome {
  error: string | null;
  data: { access_token?: string; expires_at?: string; error?: string; aadsts_code?: string | null } | null;
}

export function shouldBlockActivation(
  outcome: TokenRefreshOutcome,
): { block: true; reason: string } | { block: false } {
  if (outcome.error) return { block: true, reason: outcome.error };
  if (outcome.data?.error) return { block: true, reason: outcome.data.error };
  if (outcome.data?.access_token) return { block: false };
  return { block: true, reason: 'Could not verify the sending account.' };
}
